// extracted by mini-css-extract-plugin
export var chart = "TasteProfile-module--chart--L7DOY";
export var fill = "TasteProfile-module--fill--but-d";
export var label = "TasteProfile-module--label--hKRt-";
export var progress = "TasteProfile-module--progress--xk3za";
export var wrapper = "TasteProfile-module--wrapper--wj1y0";